import React from 'react'
import './Search.scss'
import { FiSearch } from "react-icons/fi";
import { MdClear } from "react-icons/md";

const Index = ({ searchCallBack, placeholder, className, refs,showClearButton, searchIconPlace }: any) => {
    let debounce: any;
    const handleSearch = (e: any) => {
        clearTimeout(debounce)
        debounce = setTimeout(() => {
            searchCallBack(e?.trim())
        }, 1000);
    }

    const clearSearchTab=()=>{
        if (refs?.current) {
            refs.current.value = "";
          }
    }
    return (
        <>
            <div className="position-relative">
                <span className={`position-absolute ${ searchIconPlace ? searchIconPlace : "search-icon-position-otherPage"} search-icon-color`}><FiSearch /></span>
                <input
                    ref={refs}
                    className={`search-box ${className ? className : "w-50"} search-left-space`}
                    autoComplete="off"
                    type="text"
                    name="keyword"
                    id="search"
                    placeholder={placeholder ? placeholder : 'Search'}
                    // defaultValue={searchKeyword}
                    onChange={(e) => {
                        handleSearch(e.target.value);
                    }}
                />
                {(showClearButton && refs?.current?.value) && (
                    <MdClear
                        style={{
                            position: "absolute",
                            right: "20px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "gray",
                            fontSize:"20px"
                        }}
                        onClick={() => {handleSearch(""); clearSearchTab()}} 
                    />
                )}
            </div>
        </>

    )
}

export default Index